/** @jsx jsx */

import React, { useState, useRef } from "react";
import { css, jsx } from "@emotion/react";
import bg from "../../../images/newsletter-bg.svg";

const WrapNewsLetter = () => {
    const notifyEl = useRef(null);
    const [email, setEmail] = useState('');
    const [showMsg, setShowMsg] = useState(false);
    const [success, setSuccess] = useState(false);
    return (
        <>
            <style jsx>
                {`
                    .round {
                        position: relative;
                        display: inline-block;
                    }

                    .round label {
                        background-color: #fff;
                        border: 1px solid #fd566f;
                        border-radius: 50%;
                        cursor: pointer;
                        height: 28px;
                        left: 0;
                        position: absolute;
                        top: 0;
                        width: 28px;
                    }

                    .round label:after {
                        border: 2px solid #fff;
                        border-top: none;
                        border-right: none;
                        content: "";
                        height: 6px;
                        left: 7px;
                        opacity: 0;
                        position: absolute;
                        top: 8px;
                        transform: rotate(-45deg);
                        width: 12px;
                    }

                    .round input[type="checkbox"] {
                        visibility: hidden;
                    }

                    .round input[type="checkbox"]:checked + label {
                        background-color: #fd566f;
                        border-color: #fd566f;
                    }

                    .round input[type="checkbox"]:checked + label:after {
                        opacity: 1;
                    }

                    .response {
                        position: relative;
                        text-align: center;
                        padding: 1rem;
                        font-size: 2rem;
                    }

                    .error {
                        color: #fd566f;
                        display: inline-flex;
                        align-items: baseline;
                    }

                    .success {
                        color: #39bd97;
                        display: inline-flex;
                        align-items: baseline;
                    }

                    .error-p {
                        color: #fd566f;
                        margin-left: 1rem;
                        text-align: left;
                        font-size: 1.5rem;
                    }

                    .success-p {
                        color: #39bd97;
                        margin-left: 1rem;
                        text-align: left;
                        font-size: 1.5rem;
                    }

                `}
            </style>
            <section
                id="newsletter-sign-up"
                css={css`
                    min-height: 88rem;
                    width: 100%;
                    padding: 25rem 4rem 4rem 4rem;
                    background: url(${bg}) center bottom -31rem / 100%, #fff;
                    background-repeat: no-repeat;
                    margin-bottom: -3rem;
                    padding-bottom: 8rem;
                `}
            >
                <div
                    css={css`
                        display: flex;
                        max-width: 100%;
                        justify-content: center;
                        @media (max-width: 1024px) {
                            flex-direction: column;
                        }
                    `}
                >
                    <div
                        css={css`
                            max-width: 50rem;
                            @media (max-width: 1024px) {
                                margin: auto;
                            }
                        `}
                    >
                        <h1
                            css={css`
                                font-size: 4rem;
                                line-height: 6rem;
                                color: #393972;
                                @media (max-width: 1024px) {
                                    font-size: 3rem;
                                    line-height: 4rem;
                                }
                            `}
                        >
                            A new hub for modern brands, businesses and creatives.
                        </h1>
                        <p
                            css={css`
                                font-size: 1.6rem;
                                line-height: 2rem;
                                color: #616161;
                            `}
                        >
                            The Wrap is noissue’s online publication that
                            connects our communities and shares stories about
                            modern brands, businesses and creatives.
                            <br /> <br />
                            Whether you’re a maker, a creative, or an
                            entrepreneur, you’ll discover people just like you.
                        </p>
                        <a
                            css={css`
                                font-size: 1.6rem;
                                font-weight: 400;
                                line-height: 1.6;
                                padding: 1rem 4rem;
                                color: #393972;
                                border-radius: 1rem;
                                border: 0.2rem solid #393972;
                                cursor: pointer;
                                display: inline-block;
                                margin: 2rem auto;
                            `}
                            href="mailto:press@noissue.co"
                        >
                            Feature on the wrap
                        </a>
                    </div>
                    <div
                        css={css`
                            max-width: 50%;
                            margin-left: 10rem;
                            @media (max-width: 1024px) {
                                max-width: 98%;
                                margin: auto;
                                margin-top: 5rem;
                            }
                        `}
                    >
                        <div
                            css={css`
                                display: block;
                                border-radius: 2rem;
                                box-shadow: 1rem 1rem 0 #fd566f;
                                position: relative;
                                max-width: 60rem;
                                padding: 5rem 3rem;
                                background: #ffd6de;
                                border: 0.5rem solid #fd566f;
                            `}
                        >
                            <div
                                css={css`
                                    position: absolute;
                                    left: calc(50% - 5rem);
                                    top: -2.3rem;
                                `}
                            >
                                <PencilIcon fill="#FD566F" />
                                {/* <div css={css`
                            width: 0;
                            height: 0;
                            border-top: 1.3rem solid transparent;
                            border-bottom: 1.3rem solid transparent;
                            border-left: 2rem solid #fff;
                            display: inline-block;
                            position: absolute;
                            right: 4px;
                            z-index: 1;
                            top: 6px;
                        `}/> */}
                            </div>
                            <h2
                                css={css`
                                    color: #393972;
                                    font-size: 3rem;
                                    line-height: 3rem;
                                    text-align: center;
                                    @media (max-width: 1024px) {
                                        font-size: 2rem;
                                        line-height: 2rem;
                                    }
                                `}
                            >
                                Sign up for The Wrap newsletter
                            </h2>
                            <p
                                css={css`
                                    color: #393972;
                                    font-size: 1.6rem;
                                    line-height: 2.2rem;
                                    margin: 2rem auto;
                                    text-align: center;
                                `}
                            >
                                Get the latest stories from our community and
                                branding, sustainability, design and marketing
                                tips delivered straight to your inbox.
                            </p>
                            <form
                                onSubmit={(e) => {
                                    e.preventDefault();
                                    setShowMsg(false);
                                    const dataF ={}
                                    dataF.email= email;
                                    dataF.notify=notifyEl.current.checked;
                                    dataF.source="newsletter";
                                    const requestOptions = {
                                        method: 'POST',
                                        headers: { 'Content-Type': 'application/json' },
                                        body: JSON.stringify(dataF)
                                    };

                                    const subscriptionFormPayload = {
                                        method: 'POST',
                                        headers: { 'Content-Type': 'application/json' },
                                        body: JSON.stringify({
                                            customerEmail: email,
                                            eventName: 'TheWrapNewsletterSubscriptionEvent',
                                            payload: {
                                                email,
                                                notify: notifyEl.current.checked,
                                                source: "newsletter"
                                            }
                                        })
                                    }

                                    if (email) {
                                        fetch('/api/bigcommerce/customers', requestOptions).then((res) => {
                                            if(res.status === 200 || res.status === 500) {
                                                setEmail('');
                                                setSuccess(true);
                                            }else {
                                                setSuccess(false);
                                            }
                                            setShowMsg(true);
                                        });
                                        fetch('/api/customer/generic-form/', subscriptionFormPayload).then((res) => {
                                            // FIXME: Temporarily commented until we removed the first fetch
                                            // if(res.status === 200 || res.status === 500) {
                                            //     setEmail('');
                                            //     setSuccess(true);
                                            // }else {
                                            //     setSuccess(false);
                                            // }
                                            // setShowMsg(true);
                                        });
                                    }
                                }}
                            >
                                <div
                                    css={css`
                                        display: flex;
                                        padding: 1rem 2rem;
                                        border: 0.5rem solid #fd566f;
                                        border-radius: 6rem;
                                        background: #fff;
                                        justify-content: space-between;
                                        @media (max-width: 1024px) {
                                            padding: 0.5rem 1rem;
                                        }
                                    `}
                                >
                                    <input
                                        type="email"
                                        placeholder="enter your email..."
                                        required
                                        maxLength="100"
                                        id="email"
                                        name="email"
                                        value={email}
                                        onChange={(e) =>
                                            setEmail(e.target.value)
                                        }
                                        css={css`
                                            outline: none;
                                            border: none;
                                            height: 4rem;
                                            min-width: 20rem;
                                            font-size: 1.6rem;
                                            width: 100%;
                                            color: #393972;
                                            font-weight: 600;
                                            @media (max-width: 1024px) {
                                                min-width: 15rem;
                                                height: 3em;
                                                font-size: 1.4rem;
                                            }
                                            @media (max-width: 425px) {
                                                min-width: 13rem;
                                            }

                                        `}
                                    />
                                    <button
                                        css={css`
                                            color: #fd566f;
                                            font-size: 1.8rem;
                                            padding: 1rem;
                                            font-weight: 600;
                                            cursor: pointer;
                                            @media (max-width: 1024px) {
                                                font-size: 1.4rem;
                                            }
                                            @media (max-width: 425px) {
                                                display: none;
                                            }

                                        `}
                                        type="submit"
                                    >
                                        SUBMIT
                                    </button>
                                </div>
                                <div className='response' style={{display: showMsg? 'block':'none'}}>
                                    {success && <div className='success'><i className="fa fa-check-circle" aria-hidden="true"></i><p className='success-p'>Thanks for signing up.</p></div>}
                                    {!success && <div className='error'><i className="fa fa-exclamation-triangle" aria-hidden="true"></i><p className='error-p'>There was a problem with the subscription.</p></div>}
                                </div>
                                <div>
                                <button
                                        css={css`
                                        display: none;
                                        @media (max-width: 425px) {
                                                margin: auto;
                                                display: block;
                                                color: #fd566f;
                                                padding: 1rem;
                                                font-weight: 600;
                                                cursor: pointer;
                                                font-size: 1.4rem;
                                            }
                                        `}
                                        type="submit"
                                    >
                                        SUBMIT
                                    </button>
                                </div>
                                <div
                                    css={css`
                                        margin-top: 2rem;
                                        text-align: center;
                                        position: relative;
                                        display: flex;
                                        justify-content: center;
                                    `}
                                >
                                    <div className="round">
                                        <input
                                            type="checkbox"
                                            id="checkbox"
                                            ref={notifyEl}
                                        />
                                        <label for="checkbox"></label>
                                    </div>
                                    <span
                                        for="checkbox"
                                        css={css`
                                            color: #393972;
                                            display: inline-block;
                                            margin-left: 2.5rem;
                                            font-size: 1.4rem;
                                            vertical-align: sub;
                                        `}
                                    >
                                        Please send me info about everything
                                        happening with noissue.
                                    </span>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default WrapNewsLetter;

export const PencilIcon = (color) => {
    return (
        <svg
            width="140"
            height="40"
            viewBox="0 0 140 40"
            fill="#FFF"
            xmlns="http://www.w3.org/2000/svg"
            css={css`
                z-index: 2;
            `}
        >
            <rect fill="white" width="80%" height="100%" rx="10" ry="10" />
            <path
                d="M12.21 29.1537H18.4821V26.924H12.21V25.1089H10.2305V30.9688H12.21V29.1537Z"
                fill={color.fill}
            />
            <path
                d="M18.4821 21.5235H15.2348V18.9577H18.4821V16.728H10.2305V18.9577H13.2553V21.5235H10.2305V23.7644H18.4821V21.5235Z"
                fill={color.fill}
            />
            <path
                d="M18.4821 9.04199H16.4915V12.3697H15.2348V9.04199H13.2553V12.3697H12.21V9.04199H10.2305V14.6106H18.4821V9.04199Z"
                fill={color.fill}
            />
            <path
                d="M49.4868 21.367L47.0069 12.0449H43.7263L41.1463 21.3783L38.7664 12.0449H34.7852L39.2112 27.9665H42.5586L45.2721 18.3306L47.9188 27.9665H51.3774L55.9147 12.0449H51.9334L49.4868 21.367Z"
                fill={color.fill}
            />
            <path
                d="M67.326 21.3334C68.2045 20.9973 68.9385 20.4819 69.5279 19.8096C70.1952 19.0589 70.5288 18.0841 70.5288 16.9077C70.5288 16.0785 70.3509 15.3278 69.9839 14.6668C69.6169 14.0057 69.1387 13.4903 68.5271 13.1206C67.9377 12.762 67.3149 12.4931 66.6699 12.3138C66.0249 12.1346 65.3576 12.0449 64.6793 12.0449H59.5859V27.9665H63.1668V21.804H63.3781L67.5929 27.9665H72.1079L71.8411 27.6079C70.3175 25.5127 68.7939 23.4063 67.326 21.3334ZM66.0805 18.2298C65.6134 18.5211 64.9795 18.6668 64.1899 18.6668H63.1891V15.1598H64.6125C65.2575 15.1598 65.7802 15.3278 66.1694 15.664C66.5476 16.0001 66.7366 16.4259 66.7366 16.9637C66.7255 17.5463 66.5142 17.9497 66.0805 18.2298Z"
                fill={color.fill}
            />
            <path
                d="M81.0374 12.0449L74.5762 27.9665H78.5574L79.5917 25.0981H84.7406L85.7303 27.9665H89.8339L83.8954 12.0449H81.0374ZM80.6815 22.0505L82.2273 17.7256L83.7063 22.0505H80.6815Z"
                fill={color.fill}
            />
            <path
                d="M102.633 13.143C102.044 12.7732 101.41 12.4931 100.743 12.3138C100.075 12.1346 99.3859 12.0449 98.6742 12.0449H93.5586V27.9665H97.1395V22.129H98.6742C99.3859 22.129 100.087 22.0393 100.754 21.86C101.421 21.6808 102.055 21.4007 102.644 21.0309C103.256 20.65 103.745 20.1121 104.101 19.4287C104.457 18.7452 104.646 17.9609 104.646 17.0645C104.646 16.1906 104.457 15.4063 104.09 14.734C103.723 14.0617 103.234 13.5239 102.633 13.143ZM98.1626 19.0029H97.1395V15.171H98.5852C99.2858 15.171 99.853 15.3502 100.264 15.6976C100.665 16.0449 100.865 16.5155 100.865 17.1318C100.865 18.3867 99.9753 19.0029 98.1626 19.0029Z"
                fill={color.fill}
            />
            <path
                d="M137.486 14.6106L118.303 1.31092C117.18 0.459384 115.801 0 114.4 0H110.63H108.45H7.33973C3.29176 0 0 3.31653 0 7.39496V32.605C0 36.6835 3.29176 40 7.33973 40H108.461H114.377C115.812 40 117.224 39.5182 118.359 38.6331L137.431 24.9972L137.553 24.8964C139.121 23.6415 140.011 21.7591 140 19.7311C139.989 17.7255 139.066 15.8543 137.486 14.6106ZM23.109 34.3529H7.33973C6.40558 34.3529 5.60488 33.5574 5.60488 32.605V7.39496C5.60488 6.45378 6.39446 5.64706 7.33973 5.64706H23.109V34.3529ZM111.186 25.2101C110.696 26.8908 109.707 30.5098 110.263 34.3529H109.718H28.725V5.65826H109.718V5.64706H109.751V5.65826H110.607C110.296 7.93277 110.329 10.8796 111.419 14.1513C109.784 18.5546 110.296 22.4538 111.186 25.2101ZM128.423 24.5042L115.823 33.5126C115.423 30.7339 116.268 27.8768 116.646 26.577C116.98 25.4342 116.98 24.493 116.635 23.7647C115.945 21.8151 115.489 18.8796 116.935 15.5406C117.336 14.6219 117.358 13.7703 117.002 13.0084C116.034 10.5322 115.957 8.33613 116.146 6.66667L128.534 15.2605C127.9 16.5042 127.433 18.028 127.433 19.8655C127.433 21.6807 127.845 23.2269 128.423 24.5042Z"
                fill={color.fill}
            />
        </svg>
    );
};
